// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XpEf4","toggle":"styles_toggle__hILhn","preview":"styles_preview__1bT1L"};